import { request } from '@/shared/api/request'

export const postReview = (body) => request({ url: `contract/review/send`, method: 'POST', data: body })